<div class="pdf-container">
  <h3 mat-dialog-title>{{ data.title }}</h3>
  <iframe
    *ngIf="src"
    [src]="src"
    frameBorder="0"
    scrolling="auto"
    height="200%"
    width="100%"
  >
  </iframe>
  <div mat-dialog-actions align="end">
    <button
      mat-button
      type="button"
      class="btn btn-warning"
      cdkFocusInitial
      (click)="closeDialog()"
    >
      Fermer
    </button>
  </div>
</div>
